import {DataSetConditionalDimension, DataSetDimension, DataSourceDimension, Dimension, GeneralDimension} from '../interfaces/dimensions';
import {Serializer} from '../interfaces/serializer';
import {DataSetMetric, DataSourceMetric, Metric} from '../interfaces/metrics';

export class AdReportUtils {
  public static getName(item: Serializer<GeneralDimension | DataSetDimension | DataSetConditionalDimension | DataSourceDimension | Dimension | DataSetMetric | DataSourceMetric | Metric>): string {
    if (!item) {
      return;
    }

    const group: string = AdReportUtils.getGroup(item);

    return `${item.attributes.name} ${group.length && ('- ' + group) || ''}`;
  }

  public static getGroup(item: Serializer<GeneralDimension | DataSetDimension | DataSetConditionalDimension | DataSourceDimension | Dimension | DataSetMetric | DataSourceMetric | Metric>): string {
    if (!item) {
      return;
    }

    return item?.relationships[AdReportUtils.getKey(item)]?.data && item?.relationships[AdReportUtils.getKey(item)].data?.attributes?.name || item?.relationships?.data_source?.data?.attributes?.name || '';
  }

  public static getKey(item: Serializer<GeneralDimension | DataSetDimension | DataSetConditionalDimension | DataSourceDimension | Dimension | DataSetMetric | DataSourceMetric | Metric>): string {
    if (!item) {
      return;
    }

    return item?.relationships?.hasOwnProperty(`data_set_dimensions_group`) && `data_set_dimensions_group` || `data_set_metrics_group`;
  }

}
